import React from 'react';
import { PRODUCTS } from '../config/columns.config';
import { useTheme } from '@mui/material/styles';

const TerritorySummaryHeader = ({ isSticky, config }) => {
  const theme = useTheme();
  const isSales = config?.reportCategory === 'sales';
  const budgetLabel = config?.budgetType === 'internal' ? 'Internal Budget' : 'External Budget';

  return (
    <div
      className={`${isSticky ? 'sticky top-0' : ''} z-40 border-b`}
      style={{
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.divider,
        color: theme.palette.text.primary
      }}
    >
      <div className="px-6 py-3">
        <h2 className="text-lg font-semibold" style={{ color: theme.palette.text.primary }}>Summary: Territory-wise</h2>
      </div>

      <table className="w-full text-sm border-collapse table-fixed">
        <colgroup>
          <col className="w-64" />
          {PRODUCTS.map(p => <col key={p.key} className="w-24" />)}
          <col className="w-24" />
          {isSales && (
            <>
              <col className="w-24" />
              <col className="w-24" />
              <col className="w-24" />
            </>
          )}
        </colgroup>
        <thead>
          <tr style={{ backgroundColor: theme.palette.background.default, color: theme.palette.text.secondary }}>
            <th className="p-3 text-left truncate">TERRITORY/CATEGORY</th>
            {PRODUCTS.map(p => (
              <th key={p.key} className="p-3 text-right truncate">
                {p.label}
              </th>
            ))}
            <th className="p-3 text-right truncate">Total</th>
            {isSales && (
              <>
                <th className="p-3 text-right truncate">{budgetLabel}</th>
                <th className="p-3 text-right truncate">Percentage Achieved</th>
                <th className="p-3 text-right truncate">Achieved- Pro Rata Basis</th>
              </>
            )}
          </tr>
        </thead>
      </table>
    </div>
  );
};

export default TerritorySummaryHeader;